/* text-area.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._313842dnbC%7Bmargin-top%3A0%7D%0A._0adFHsdnbC%7Bmargin-right%3A0%7D%0A._1DCdHidnbC%7Bmargin-bottom%3A0%7D%0A._2XsHFMdnbC%7Bmargin-left%3A0%7D%0A._2O5Vij7dHp%7Bflex-grow%3A1%7D%0A._3YEZNO7dHp%7Bflex-shrink%3A1%7D%0A._1bHrqEN91d%7Bflex-basis%3A100%25%7D%0A._0bjKvDKTcp%7Bborder-radius%3Avar(--ds-radius-medium%2C6px)%7D%0A._2sNsIgmnOE%7Bfont%3Avar(--ds-font-body%2Cnormal%20400%2014px%2F20px%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D%0A._2xIroY98eZ%7Boutline-color%3AcurrentColor%7D%0A._497WNwYbGa%7Boutline-style%3Anone%7D%0A._2zndICT6kp%7Boutline-width%3Amedium%7D%0A._4bt5LAIZbP%7Boverflow-x%3Aauto%7D%0A._2WAcuGIZbP%7Boverflow-y%3Aauto%7D%0A._2V7sgONvrM%7Bborder-width%3Avar(--ds-border-width%2C1px)%7D%0A._3iDTPbvLZJ%7Bdisplay%3Ablock%7D%0A._24h04i2Njc%7Bbox-sizing%3Aborder-box%7D%0A._39xV02N91d%7Bwidth%3A100%25%7D%0A._4ouGXIdnbC%7Bmin-width%3A0%7D%0A._1EqgXlN91d%7Bmax-width%3A100%25%7D%0A._1mT5xdRAKS%7Bposition%3Arelative%7D%0A._1UtDYzy7kJ%7Bcolor%3Avar(--ds-text%2C%23292a2e)%7D%0A._1T2N03wPeg%7Bword-wrap%3Abreak-word%7D%0A._2IasYonod9%5Bdata-invalid%5D%3Anot(%3Afocus)%7Bborder-color%3Avar(--ds-border-danger%2C%23e2483d)%7D%0A._03v5H87Cj1%5Bdata-invalid%5D%3Anot(%3Afocus)%7Bbackground-color%3Avar(--ds-background-input%2C%23fff)%7D%0A._32yk65FKgL%5Bdata-invalid%5D%3Anot(%3Afocus)%7Bbox-shadow%3Ainset%200%200%200%20var(--ds-border-width%2C1px)%20var(--ds-border-danger%2C%23e2483d)%7D%0A._24bGaTot27%3Adisabled%7Bcolor%3Avar(--ds-text-disabled%2C%23080f214a)%7D%0A._02aXbKsyl5%3Adisabled%7Bcursor%3Anot-allowed%7D%0A._0OS5PY7dHp%3Adisabled%7B-webkit-opacity%3A1%7D%0A._1kg4OzZqHV%3Adisabled%7B-webkit-text-fill-color%3Aunset%7D%0A._3tCyJvYbGa%3A%3A-ms-clear%7Bdisplay%3Anone%7D%0A._2DoaPjYbGa%3Ainvalid%7Bbox-shadow%3Anone%7D%0A._3pNDujnod9%3Ahover%3Anot(%3A-moz-read-only)%3Anot(%3Afocus)%5Bdata-invalid%5D%7Bborder-color%3Avar(--ds-border-danger%2C%23e2483d)%7D%0A._3pNDujnod9%3Ahover%3Anot(%3Aread-only)%3Anot(%3Afocus)%5Bdata-invalid%5D%7Bborder-color%3Avar(--ds-border-danger%2C%23e2483d)%7D%0A._1cY5OfqWX3%3Ahover%3Anot(%3A-moz-read-only)%3Anot(%3Afocus)%5Bdata-invalid%5D%7Bbackground-color%3Avar(--ds-background-input-hovered%2C%23f8f8f8)%7D%0A._1cY5OfqWX3%3Ahover%3Anot(%3Aread-only)%3Anot(%3Afocus)%5Bdata-invalid%5D%7Bbackground-color%3Avar(--ds-background-input-hovered%2C%23f8f8f8)%7D%0A._0sBZ7MFKgL%3Ahover%3Anot(%3A-moz-read-only)%3Anot(%3Afocus)%5Bdata-invalid%5D%7Bbox-shadow%3Ainset%200%200%200%20var(--ds-border-width%2C1px)%20var(--ds-border-danger%2C%23e2483d)%7D%0A._0sBZ7MFKgL%3Ahover%3Anot(%3Aread-only)%3Anot(%3Afocus)%5Bdata-invalid%5D%7Bbox-shadow%3Ainset%200%200%200%20var(--ds-border-width%2C1px)%20var(--ds-border-danger%2C%23e2483d)%7D%0A._30pU6CVrZW%3Ahover%3Anot(%3A-moz-read-only)%3Anot(%3Afocus)%3Adisabled%7Bbackground-color%3Avar(--ds-background-disabled%2C%230515240f)%7D%0A._30pU6CVrZW%3Ahover%3Anot(%3Aread-only)%3Anot(%3Afocus)%3Adisabled%7Bbackground-color%3Avar(--ds-background-disabled%2C%230515240f)%7D%0A._3AxjleKGUX%3A%3A-moz-placeholder%7Bcolor%3Avar(--ds-text-subtlest%2C%236b6e76)%7D%0A._3AxjleKGUX%3A%3Aplaceholder%7Bcolor%3Avar(--ds-text-subtlest%2C%236b6e76)%7D%0A._3MV4MUot27%3Adisabled%3A%3A-moz-placeholder%7Bcolor%3Avar(--ds-text-disabled%2C%23080f214a)%7D%0A._3MV4MUot27%3Adisabled%3A%3Aplaceholder%7Bcolor%3Avar(--ds-text-disabled%2C%23080f214a)%7D%0A._1yFQeXQWvZ%5Bdata-compact%5D%7Bline-height%3A1.1428571428571428%7D%0A._3TNCtG1AUN%3Anot(%5Bdata-compact%5D)%7Bline-height%3A1.4285714285714286%7D%0A._3OInhJnXvL%5Bdata-invalid%5D%3Afocus%7Bborder-color%3Avar(--ds-border-focused%2C%234688ec)%7D%0A._1xHRfPutHW%5Bdata-invalid%5D%3Afocus%7Bbackground-color%3Avar(--ds-background-input-pressed%2C%23fff)%7D%0A._4skx3vPhRM%5Bdata-invalid%5D%3Afocus%7Bbox-shadow%3Ainset%200%200%200%20var(--ds-border-width%2C1px)%20var(--ds-border-focused%2C%234688ec)%7D%0A._23rrnH5Vpu%7Btransition%3Abackground-color%20.2s%20ease-in-out%2Cborder-color%20.2s%20ease-in-out%7D%0A._23rrnHGIwA%7Btransition%3Avar(--ds-input%2Cbackground-color%20border-color%20box-shadow%20.15s%20cubic-bezier(.4%2C1%2C.6%2C1))%7D%0A._3AxjleZpcK%3A%3A-moz-placeholder%7Bcolor%3Avar(--ds-text-subtle%2C%23505258)%7D%0A._3AxjleZpcK%3A%3Aplaceholder%7Bcolor%3Avar(--ds-text-subtle%2C%23505258)%7D%0A._3hxITi6wH8%7Bborder-style%3Asolid%7D%0A._1mHXSFHKt7%3Anot(%3Afocus)%7Bborder-color%3Avar(--ds-border-input%2C%238c8f97)%7D%0A._3OEoix7Cj1%3Anot(%3Afocus)%7Bbackground-color%3Avar(--ds-background-input%2C%23fff)%7D%0A._39nh0ghQC5%3Adisabled%3Anot(%3Afocus)%7Bborder-color%3Avar(--ds-border-disabled%2C%230515240f)%7D%0A._2jpXBkVrZW%3Adisabled%3Anot(%3Afocus)%7Bbackground-color%3Avar(--ds-background-disabled%2C%230515240f)%7D%0A._31SgFAHKt7%3Ahover%3Anot(%3A-moz-read-only)%3Anot(%3Afocus)%7Bborder-color%3Avar(--ds-border-input%2C%238c8f97)%7D%0A._31SgFAHKt7%3Ahover%3Anot(%3Aread-only)%3Anot(%3Afocus)%7Bborder-color%3Avar(--ds-border-input%2C%238c8f97)%7D%0A._2zr3nGqWX3%3Ahover%3Anot(%3A-moz-read-only)%3Anot(%3Afocus)%7Bbackground-color%3Avar(--ds-background-input-hovered%2C%23f8f8f8)%7D%0A._2zr3nGqWX3%3Ahover%3Anot(%3Aread-only)%3Anot(%3Afocus)%7Bbackground-color%3Avar(--ds-background-input-hovered%2C%23f8f8f8)%7D%0A._3LfWyLFQfX%5Bdata-compact%5D%7Bpadding-block-start%3Avar(--ds-space-025%2C2px)%7D%0A._2vsVfZFQfX%5Bdata-compact%5D%7Bpadding-block-end%3Avar(--ds-space-025%2C2px)%7D%0A._2DQpWtXJux%5Bdata-compact%5D%7Bpadding-inline-start%3A7px%7D%0A._0SosFGXJux%5Bdata-compact%5D%7Bpadding-inline-end%3A7px%7D%0A._1CDq3qgVvo%3Anot(%5Bdata-compact%5D)%7Bpadding-block-start%3Avar(--ds-space-075%2C6px)%7D%0A._2FTXAcgVvo%3Anot(%5Bdata-compact%5D)%7Bpadding-block-end%3Avar(--ds-space-075%2C6px)%7D%0A._0tVs2sXJux%3Anot(%5Bdata-compact%5D)%7Bpadding-inline-start%3A7px%7D%0A._3JVwBfXJux%3Anot(%5Bdata-compact%5D)%7Bpadding-inline-end%3A7px%7D%0A._0xkEdpnXvL%3Afocus%7Bborder-color%3Avar(--ds-border-focused%2C%234688ec)%7D%0A._1iy5hxutHW%3Afocus%7Bbackground-color%3Avar(--ds-background-input-pressed%2C%23fff)%7D%0A._0ui43CPhRM%3Afocus%7Bbox-shadow%3Ainset%200%200%200%20var(--ds-border-width%2C1px)%20var(--ds-border-focused%2C%234688ec)%7D%0A._2UNgvCnXvL%3Adisabled%3Afocus%7Bborder-color%3Avar(--ds-border-focused%2C%234688ec)%7D%0A._1LO7QkVrZW%3Adisabled%3Afocus%7Bbackground-color%3Avar(--ds-background-disabled%2C%230515240f)%7D%0A._1mHXSFjOvk%3Anot(%3Afocus)%7Bborder-color%3Atransparent%7D%0A._3OEoixjOvk%3Anot(%3Afocus)%7Bbackground-color%3Atransparent%7D%0A._3hxITiYbGa%7Bborder-style%3Anone%7D%0A._31SgFAjOvk%3Ahover%3Anot(%3A-moz-read-only)%3Anot(%3Afocus)%7Bborder-color%3Atransparent%7D%0A._31SgFAjOvk%3Ahover%3Anot(%3Aread-only)%3Anot(%3Afocus)%7Bborder-color%3Atransparent%7D%0A._2zr3nGjOvk%3Ahover%3Anot(%3A-moz-read-only)%3Anot(%3Afocus)%7Bbackground-color%3Atransparent%7D%0A._2zr3nGjOvk%3Ahover%3Anot(%3Aread-only)%3Anot(%3Afocus)%7Bbackground-color%3Atransparent%7D%0A._0SosFGgVvo%5Bdata-compact%5D%7Bpadding-inline-end%3Avar(--ds-space-075%2C6px)%7D%0A._2DQpWtgVvo%5Bdata-compact%5D%7Bpadding-inline-start%3Avar(--ds-space-075%2C6px)%7D%0A._3JVwBfgVvo%3Anot(%5Bdata-compact%5D)%7Bpadding-inline-end%3Avar(--ds-space-075%2C6px)%7D%0A._0tVs2sgVvo%3Anot(%5Bdata-compact%5D)%7Bpadding-inline-start%3Avar(--ds-space-075%2C6px)%7D%0A._0xkEdpjOvk%3Afocus%7Bborder-color%3Atransparent%7D%0A._1iy5hxjOvk%3Afocus%7Bbackground-color%3Atransparent%7D%0A._0ui43Cw5zn%3Afocus%7Bbox-shadow%3Ainset%200%200%200%20var(--ds-border-width%2C1px)%20transparent%7D%0A%40media%20(pointer%3Acoarse)%20and%20(max-width%3A30rem)%7B._1gitD220Hp%7Bfont%3Avar(--ds-font-body-large%2Cnormal%20400%201pc%2F24px%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D%7D%0A._0WKd3Gfx9v%7Bfont-family%3Avar(--ds-font-family-code%2C%22Atlassian%20Mono%22%2Cui-monospace%2CMenlo%2C%22Segoe%20UI%20Mono%22%2C%22Ubuntu%20Mono%22%2Cmonospace)%7D%0A%40media%20(pointer%3Acoarse)%20and%20(max-width%3A30rem)%7B._1gitD220Hp%7Bfont%3Avar(--ds-font-body-large%2Cnormal%20400%201pc%2F24px%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D._3n0EfXdh5F%7Bfont-family%3Avar(--ds-font-family-code%2C%22Atlassian%20Mono%22%2Cui-monospace%2CMenlo%2C%22Segoe%20UI%20Mono%22%2C%22Ubuntu%20Mono%22%2Cmonospace)%21important%7D%7D%0A._2HIj7GD4qA%7Bresize%3Ahorizontal%7D%0A._2HIj7GbI28%7Bresize%3Avertical%7D%0A._2HIj7GZSoF%7Bresize%3Aboth%7D%0A._2HIj7GYbGa%7Bresize%3Anone%7D%0A._22P5CgPgdP%5Bdata-compact%5D%7Bmin-height%3Avar(--_6ny3x7)%7D%0A._2Ombu6q5bj%3Anot(%5Bdata-compact%5D)%7Bmin-height%3Avar(--_eorxnz)%7D");

































































































import React, { forwardRef, memo, useCallback, useEffect, useMemo, useRef } from 'react';
import { usePlatformLeafEventHandler } from '@atlaskit/analytics-next/usePlatformLeafEventHandler';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { type TextAreaProps } from './types';
const packageName = (process.env._PACKAGE_NAME_ as string);
const packageVersion = (process.env._PACKAGE_VERSION_ as string);
const analyticsParams = {
  componentName: 'textArea',
  packageName,
  packageVersion
};
const lineHeightBase = 20;
const lineHeightCompact = 16;
const compactVerticalPadding = 2;
const verticalPadding = 6;
const borderWidth = 2;
const baseStyles = null;
const inputMotionStyles = {
  legacy: "_23rrnH5Vpu",
  base: "_23rrnHGIwA"
};
const finessePlaceholderStyles = null;
const appearanceStyles = {
  standard: "_3hxITi6wH8 _1mHXSFHKt7 _3OEoix7Cj1 _39nh0ghQC5 _2jpXBkVrZW _31SgFAHKt7 _2zr3nGqWX3 _3LfWyLFQfX _2vsVfZFQfX _2DQpWtXJux _0SosFGXJux _1CDq3qgVvo _2FTXAcgVvo _0tVs2sXJux _3JVwBfXJux _0xkEdpnXvL _1iy5hxutHW _0ui43CPhRM _2UNgvCnXvL _1LO7QkVrZW",
  subtle: "_3hxITi6wH8 _1mHXSFjOvk _3OEoixjOvk _31SgFAHKt7 _2zr3nGqWX3 _3LfWyLFQfX _2vsVfZFQfX _2DQpWtXJux _0SosFGXJux _1CDq3qgVvo _2FTXAcgVvo _3JVwBfXJux _0tVs2sXJux _0xkEdpnXvL _1iy5hxutHW _0ui43CPhRM",
  none: "_3hxITiYbGa _1mHXSFjOvk _3OEoixjOvk _31SgFAjOvk _2zr3nGjOvk _3LfWyLFQfX _0SosFGgVvo _2vsVfZFQfX _2DQpWtgVvo _1CDq3qgVvo _3JVwBfgVvo _2FTXAcgVvo _0tVs2sgVvo _0xkEdpjOvk _1iy5hxjOvk _0ui43Cw5zn"
};

// iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on touch devices with small viewports, the textarea uses font.body (default),
// and font.body.large (16px) for touch devices (pointer: coarse) with screens narrower than 30rem.
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e

const fontStyles = {
  default: "_2sNsIgmnOE _1gitD220Hp",
  monospace: "_2sNsIgmnOE _0WKd3Gfx9v _1gitD220Hp _3n0EfXdh5F"
};
const resizeStyles = {
  horizontal: "_2HIj7GD4qA",
  vertical: "_2HIj7GbI28",
  auto: "_2HIj7GZSoF",
  smart: "_2HIj7GYbGa",
  none: "_2HIj7GYbGa"
};
const setSmartHeight = (el: HTMLTextAreaElement) => {
  // Always reset height to auto before calculating new height
  el.style.height = 'auto';
  const borderHeight = borderWidth;
  const paddingBoxHeight: number = el.scrollHeight;
  const borderBoxHeight: number = paddingBoxHeight + borderHeight * 2;
  el.style.height = `${borderBoxHeight}px`;
};
const InnerTextArea: React.ForwardRefExoticComponent<React.PropsWithoutRef<TextAreaProps> & React.RefAttributes<HTMLElement>> = forwardRef((props: TextAreaProps, ref) => {
  const ourRef = useRef<HTMLTextAreaElement | null>(null);
  const {
    resize = 'smart',
    appearance = 'standard',
    isCompact = false,
    isRequired = false,
    isReadOnly = false,
    isDisabled = false,
    isInvalid = false,
    isMonospaced = false,
    minimumRows = 2,
    testId,
    maxHeight = '50vh',
    onBlur,
    onFocus,
    onChange,
    value,
    style,
    ...rest
  } = props;
  const isInputMotionEnabled = fg('platform-dst-motion-uplift-input');
  const isInteractive = !isDisabled && !isReadOnly;
  const borderHeight = useMemo(() => appearance === 'none' ? 2 : 1, [appearance]);
  useEffect(() => {
    const el: HTMLTextAreaElement | null = ourRef.current;
    if (resize === 'smart' && el) {
      setSmartHeight(el);
    }
  }, [resize, value]);
  const onBlurWithAnalytics = usePlatformLeafEventHandler({
    fn: (event: React.FocusEvent<HTMLTextAreaElement>) => {
      onBlur && onBlur(event);
    },
    action: 'blurred',
    ...analyticsParams
  });
  const onFocusWithAnalytics = usePlatformLeafEventHandler({
    fn: (event: React.FocusEvent<HTMLTextAreaElement>) => {
      onFocus && onFocus(event);
    },
    action: 'focused',
    ...analyticsParams
  });
  const getTextAreaRef = (elementRef: HTMLTextAreaElement | null) => {
    ourRef.current = elementRef;
    if (ref && typeof ref === 'object') {
      ref.current = elementRef;
    }
    if (ref && typeof ref === 'function') {
      ref(elementRef);
    }
  };
  const handleOnChange: React.ChangeEventHandler<HTMLTextAreaElement> = useCallback(e => {
    const el: HTMLTextAreaElement | null = ourRef.current;
    if (resize === 'smart' && el) {
      setSmartHeight(el);
    }
    onChange && onChange(e);
  }, [onChange, resize]);
  const controlProps = {
    'data-invalid': isInvalid ? isInvalid : undefined,
    'data-compact': isCompact ? isCompact : undefined,
    'data-testid': testId ? testId : undefined
  };
  const compactMinHeightStyles = null;
  return <textarea {...controlProps} value={value} disabled={isDisabled} readOnly={isReadOnly} required={isRequired} ref={getTextAreaRef} onChange={handleOnChange} onBlur={onBlurWithAnalytics} onFocus={onFocusWithAnalytics} rows={minimumRows} {...rest} className={ax(["_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _2O5Vij7dHp _3YEZNO7dHp _1bHrqEN91d _0bjKvDKTcp _2sNsIgmnOE _2xIroY98eZ _497WNwYbGa _2zndICT6kp _4bt5LAIZbP _2WAcuGIZbP _2V7sgONvrM _3iDTPbvLZJ _24h04i2Njc _39xV02N91d _4ouGXIdnbC _1EqgXlN91d _1mT5xdRAKS _1UtDYzy7kJ _1T2N03wPeg _2IasYonod9 _03v5H87Cj1 _32yk65FKgL _24bGaTot27 _02aXbKsyl5 _0OS5PY7dHp _1kg4OzZqHV _3tCyJvYbGa _2DoaPjYbGa _3pNDujnod9 _1cY5OfqWX3 _0sBZ7MFKgL _30pU6CVrZW _3AxjleKGUX _3MV4MUot27 _1yFQeXQWvZ _3TNCtG1AUN _3OInhJnXvL _1xHRfPutHW _4skx3vPhRM", !isInputMotionEnabled && inputMotionStyles.legacy, isInputMotionEnabled && isInteractive && inputMotionStyles.base, fg('platform-dst-tokens-finesse') && "_3AxjleZpcK", appearanceStyles[appearance], fontStyles[isMonospaced ? 'monospace' : 'default'], resizeStyles[resize], "_22P5CgPgdP _2Ombu6q5bj"])} style={{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    ...style,
    maxHeight,
    "--_6ny3x7": ix(lineHeightCompact * minimumRows + compactVerticalPadding * 2 + borderHeight * 2, "px"),
    "--_eorxnz": ix(lineHeightBase * minimumRows + verticalPadding * 2 + borderHeight * 2, "px")
  }} />;
});

/**
 * __Text area__
 *
 * A text area lets users enter long form text which spans over multiple lines.
 *
 * - [Examples](https://atlassian.design/components/textarea/examples)
 * - [Code](https://atlassian.design/components/textarea/code)
 * - [Usage](https://atlassian.design/components/textarea/usage)
 */
const TextArea: React.MemoExoticComponent<React.ForwardRefExoticComponent<Omit<TextAreaProps, 'ref'> & React.RefAttributes<HTMLTextAreaElement>>> = memo(forwardRef<HTMLTextAreaElement, TextAreaProps>((props: TextAreaProps, ref: React.Ref<HTMLTextAreaElement>) => <InnerTextArea ref={ref} {...props} />));
TextArea.displayName = 'TextArea';
export default TextArea;